<p>
  Under the pension plan, the income is based on your projected salary to retirement and
  guaranteed for your life (and potentially your spouse's life at a reduced amount; see your DB Pension Plan Statement
  to learn more about survivor benefits).
</p>